import { Box, Typography, useTheme, Stack } from "@mui/material";
import { tokens } from "../theme";

const InfoBox = ({ title, subtitle, info, icon }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Stack m="3px">
            <Stack direction={"row"} spacing={1}>
                {icon}
                <Typography
                    variant="h4"
                    fontWeight="bold"
                    sx={{ color: colors.grey[100] }}
                >
                    {title}
                </Typography>
            </Stack>
            <Box display="flex" justifyContent="space-between" mt="2px" ml="2px">
                <Typography variant="h5" sx={{ color: colors.greenAccent[500] }}>
                    {subtitle}
                </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" mt="2px" ml="2px">
                <Typography
                    variant="h5"
                    fontStyle="italic"
                    sx={{ color: info ? colors.greenAccent[600] : colors.redAccent[600] }}
                >
                    {info ? info : "Not specified"}
                </Typography>
            </Box>

        </Stack>
    );
};

export default InfoBox;